import api from "@/lib/axios";
import type { Preset, PaginatedPresetsResponse, UrlOperation } from "@/types/presets";
import { AxiosError } from "axios";

export const saveScrapingPreset = async (payload: {
  name: string;
  description?: string;
  extraction_prompt: string;
  ai_output_format: string;
  urls: { url: string; actions: UrlOperation[] }[];
  is_published?: boolean;
  stagehand_mode?: boolean;
  use_proxy?: boolean;
  proxy_country?: string;
  crawler_mode?: string;
  extract_content_only?: boolean;
  schema_json?: string | null;
  screenshot?: boolean;
  full_page_screenshot?: boolean;
}) => {
  const res = await api.post("/presets", payload);
  return res.data;
};

export const fetchScrapingPresets = async (
  page: number = 1,
  limit: number = 10
): Promise<PaginatedPresetsResponse> => {
  const res = await api.get("/presets", {
    params: {
      page,
      limit,
    },
  });
  return res.data.data;
};

export const updateScrapingPreset = async (
  uuid: string,
  data: { name?: string; description?: string }
) => {
  const res = await api.put(`/presets/${uuid}`, data);
  return res.data;
};

export const deleteScrapingPreset = async (uuid: string) => {
  const res = await api.delete(`/presets/${uuid}`);
  return res.data;
};

export const getScrapingPresetByUuid = async (uuid: string): Promise<Preset> => {
  try {
    const res = await api.get(`/presets/${uuid}`);
    return res.data.data;
  } catch (error) {
    // Provide more specific error messages
    const axiosError = error as AxiosError<{ message: string }>;
    if (axiosError.response?.status === 404) {
      throw new Error(`Preset not found. It may have been deleted or the URL is incorrect.`);
    } else if (axiosError.response?.status === 403) {
      throw new Error(`You don't have permission to access this preset.`);
    } else {
      throw new Error(
        `Failed to load preset: ${axiosError.response?.data?.message || axiosError.message}`
      );
    }
  }
};
